import React, { Component } from "react";
import PaginationSelectorItem from "./PaginationSelectorItem";
import PaginationHasMoreSelectors from "./PaginationHasMoreSelectors";
import ArrowLeft from "../Arrows/ArrowLeft";
import ArrowRight from "../Arrows/ArrowRight";

export default class Pagination extends Component {
	constructor(props) {
		super(props);
	}

	setCurrentPage = nextPage => {
		window.scrollTo(0, 0);
		if (this.props.handleChangePage) {
			return this.props.handleChangePage(nextPage);
		}
	};

	// Utilizado pela "seta" = '>'
	increaseCurrentPage = () => {
		this.setCurrentPage(this.props.currentPage + 1);
	};

	// Utilizado pela "seta" = '<'
	decreaseCurrentPage = () => {
		this.setCurrentPage(this.props.currentPage - 1);
	};

	// Retorna quantas paginas tera ao todo
	calculeNumberOfPages() {
		return Math.ceil(this.props.totalRegisters / this.props.registersPerPage);
	}

	calculeSelectorPageToStartShow() {
		return this.props.currentPage === 1 ? 1 : this.props.currentPage - 2;
	}

	renderPagesSelectors() {
		const pages = [];
		if (this.props.currentPage === this.props.maxPageSelectorToShow + 1) {
			for (
				let x = this.props.currentPage;
				x < this.props.currentPage + this.props.maxPageSelectorToShow;
				x++
			) {
				if (x > 1 && x < this.calculeNumberOfPages()) {
					pages.push({ value: x });
				}
			}
		} else if (this.props.currentPage > this.props.maxPageSelectorToShow) {
			for (
				let x = this.props.currentPage - 2;
				x < this.props.currentPage + this.props.maxPageSelectorToShow - 1;
				x++
			) {
				if (x > 1 && x < this.calculeNumberOfPages()) {
					pages.push({ value: x });
				}
			}
		} else if (
			this.props.currentPage >=
			this.calculeNumberOfPages() - this.props.maxPageSelectorToShow
		) {
			for (
				let x = this.calculeNumberOfPages() - this.props.maxPageSelectorToShow;
				x < this.calculeNumberOfPages();
				x++
			) {
				if (x > 1 && x < this.calculeNumberOfPages()) {
					pages.push({ value: x });
				}
			}
		} else {
			for (let x = 0; x < this.props.maxPageSelectorToShow + 2; x++) {
				if (x > 1 && x < this.calculeNumberOfPages()) {
					pages.push({ value: x });
				}
			}
		}
		return pages.map(item => (
			<PaginationSelectorItem
				key={item.value}
				value={item.value}
				currentPage={this.props.currentPage}
				onClick={e => this.setCurrentPage(item.value)}
				data-action="pagination-item-select"
			/>
		));
	}

	render() {
		if (this.calculeNumberOfPages() > 1) {
			return (
				<div className="offers-pagination">
					<ul className="offers-pagination--ul">
						{this.props.currentPage > 1 && (
							<li className="offers-pagination--li">
								<ArrowLeft
									className="offers-pagination--li--button  pagination--arrow-left"
									onClick={this.decreaseCurrentPage}
									data-action="pagination-dec-page"
								/>
							</li>
						)}
						<div className="offers-pagination__page-number-selectors">
							<PaginationSelectorItem
								value={1}
								currentPage={this.props.currentPage}
								onClick={e => this.setCurrentPage(1)}
							/>

							{/* Exibira quando houverem mais resultados mas que o limite defininido por props nao consiga renderizar tudo*/}
							{this.props.currentPage - this.props.maxPageSelectorToShow > 0 && (
								<PaginationHasMoreSelectors />
							)}

							{this.renderPagesSelectors()}

							{/* Exibira quando houverem mais resultados mas que o limite defininido por props nao consiga renderizar tudo*/}
							{this.props.currentPage <=
								this.calculeNumberOfPages() - this.props.maxPageSelectorToShow && (
								<PaginationHasMoreSelectors />
							)}

							<PaginationSelectorItem
								value={this.calculeNumberOfPages()}
								currentPage={this.props.currentPage}
								onClick={e => this.setCurrentPage(this.calculeNumberOfPages())}
								data-action="pagination-current"
							/>
						</div>
						{this.props.currentPage < Math.ceil(this.calculeNumberOfPages()) && (
							<li className="offers-pagination--li">
								<ArrowRight
									className="offers-pagination--li--button pagination--arrow-right"
									onClick={this.increaseCurrentPage}
									data-action="pagination-inc-page"
								/>
							</li>
						)}
					</ul>
				</div>
			);
		}

		return false;
	}
}
